const formatTimeToDisplay = (hours: number = 0, emptyValue: string = '-') => {
  const hoursPart = Math.floor(hours);
  const minutes = Math.round((hours - hoursPart) * 60);
  if (hoursPart === 0 && minutes === 0) {
    return emptyValue;
  }
  return `${hoursPart ? `${hoursPart}h ` : ''}${minutes ? `${minutes}m` : ''}`;
};

export default formatTimeToDisplay;
